import React, { useEffect, useState } from 'react';

function ShowImage(props) {
    const { showImage, setShowImage } = props;
    const { isOpen, product } = showImage;
    const images = product?.image;
    const [selectedImg, setSelectedImg] = useState('');

    useEffect(() => {
        images ? setSelectedImg(images[0]) : setSelectedImg('');
        // eslint-disable-next-line
    }, [product]);

    return (
        <>
            {isOpen ? <div className='back'>
                <div className="dialogue-container flex-column pb-3">
                    {images?.length !== 0 && images ? <>
                        <img className='image' src={selectedImg} alt="..." />
                        <div className="imgContainer">
                            {images?.map((img, i) => {
                                return <img className={`selections ${selectedImg === img ? 'selected' : ''}`} key={i} src={img} alt='...' onClick={() => {
                                    setSelectedImg(img);
                                }} />
                            })}
                        </div>
                    </>
                        : <p className='no-image'>No Image to Show</p>}
                    <button onClick={() => {
                        setShowImage({ ...showImage, isOpen: false });
                    }} className='btn btn-secondary'>OK</button>
                </div>
            </div> : null}
        </>
    )
}

export default ShowImage
